'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Dropzone = require('dropzone');
const Ajax = require('common/infra/ajax');
const Snackbar = require('common/util/snackbar');
const StorageAPI = require('data/infra/api/storage/index');

/**
 * コンテンツをアップロードするためのクラス
 * @constructs
 *
 * @param params
 * @param params.getUploadURL {function} - アップロード用 URL 取得用の function
 * @param option.accept {array} - アップロードできるファイルの種類を文字列の配列で渡します
 *    サポートしているのは 'image', 'xls' です。
 *    未指定の場合は全種類のファイルを受け入れます。
 */

module.exports = Mn.View.extend({
    template: false,
    className: 'dropzone',
    imageOnly: false,
    getUploadURL: function() {
        return StorageAPI.getUploadURL(this._projectId);
    },
    initialize: function(params) {
        _.bindAll(
            this,
            '_onAddedFile',
            '_onAddedFiles',
            '_onSuccess',
            '_onError',
            '_onProcessing',
            '_onMaxFilesExceeded',
            '_onMaxFilesReached'
        );
        this._projectId = params.projectId
    },

    onRender: function() {
        let p = {
            paramName: 'blob',
            url: 'tmp',
            parallelUploads: 1,
            maxFilesize: 1024,
            filesizeBase: 'megabyte',
            maxFiles: 1,
            timeout: 100,
            acceptedFiles: this._getAcceptedMimeTypes()
        };

        p = _.extend(p, i18n.t('uploader', {returnObjects: true}));
        this.dzoption = p;

        this.$dz = new Dropzone(this.$el[0], this.dzoption);
        this.$dz.on('addedfile', this._onAddedFile);
        this.$dz.on('addedfiles', this._onAddedFiles);
        this.$dz.on('success', this._onSuccess);
        this.$dz.on('error', this._onError);
        this.$dz.on('processing', this._onProcessing);
        this.$dz.on('maxfilesexceeded', this._onMaxFilesExceeded);
        this.$dz.on('maxfilesreached', this._onMaxFilesReached);

        this.getUploadURL()
            .then(data => {
                this.setUploadURL(data);
                this.trigger('ready');
            });
    },

    _isAcceptImage: function() {
        return _.contains(this.getOption('accept'), 'image');
    },

    _isAcceptXLS: function() {
        return _.contains(this.getOption('accept'), 'xls');
    },

    _getAcceptedMimeTypes: function() {
        const accept = this.getOption('accept');
        if(!accept) {
            return null;
        }

        let acceptedFiles = [];
        if(this._isAcceptImage()) {
            acceptedFiles.push('image/*')
        }

        if(this._isAcceptXLS()) {
            acceptedFiles.push('application/vnd.ms-excel');
            // xlsx はまだサポートしない
            // acceptedFiles.push('\tapplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }

        return acceptedFiles.join(',');
    },

    setUploadURL: function(data) {
        this.$dz.options.url = data.upload_url;
    },

    _onAddedFile: function(file) {
        // Mac OS で xls を添付すると file.type が空になる場合がある。
        // その場合に Dropzone の accept がエラーを返さないように acceptedFiles を上書きする
        // https://github.com/enyo/dropzone/issues/1476
        if(this._isAcceptXLS() && file.type == '') {
            this.$dz.options.acceptedFiles = null;
        }

        this.getUploadURL()
            .then(data => {
                this.setUploadURL(data)
            });
    },

    /**
     * ファイルの追加完了後に呼ばれる
     * @param files
     * @private
     */
    _onAddedFiles: function(files) {
        // Mac OS で xls を添付すると file.type が空になる場合がある。
        // その場合に Dropzone の accept がエラーを返さないように acceptedFiles を上書きする
        // https://github.com/enyo/dropzone/issues/1476
        if(this._isAcceptXLS() && files[0].type == '') {
            this.$dz.options.acceptedFiles = this._getAcceptedMimeTypes();
        }
    },

    addFile: function(file) {
        this.$dz.addFile(file);
    },

    _onSuccess: function(file, responseText) {
        const j = responseText;
        this.triggerMethod('addedfile', file);
        this.triggerMethod('success', file, j);
    },

    _onError: function(file, errorMessage, xhr) {
        this.triggerMethod('error', file, errorMessage);

        if(xhr && xhr.status != 401) {
            const type = Ajax.getAjaxErrorType(xhr, 'error');
            const errorMessage = Ajax.getErrorContent(type);
            if(errorMessage) {
                Snackbar.error(errorMessage);
            }
        } else if (errorMessage) {
            Snackbar.error(errorMessage);
        }

        this.$dz.removeAllFiles();
    },

    _onProcessing: function() {
        this.triggerMethod('processing');
    },

    _onMaxFilesExceeded: function(file) {
        this.triggerMethod('maxfilesexceeded');
        this.$dz.removeAllFiles();
        this.$dz.addFile(file)
    },

    _onMaxFilesReached: function() {
        // this.$dz.disable();
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/uploader.js